module.exports = __webpack_public_path__ + "static/img/12.822e9753.jpg";